/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Finals_Time_DescInputs */



/**
* | output |
* | --- |
* | "separate duration (0 = use round time)" |
*
* @param {Og_Cfg_Finals_Time_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_finals_time_desc = /** @type {((inputs?: Og_Cfg_Finals_Time_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Finals_Time_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("durée séparée (0 = utiliser la durée de ronde)")
	if (locale === "es") return /** @type {LocalizedString} */ ("duración independiente (0 = usar tiempo de ronda)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("duração separada (0 = usar tempo da rodada)")
	if (locale === "it") return /** @type {LocalizedString} */ ("durata separata (0 = uguale al round)")
	return /** @type {LocalizedString} */ ("separate duration (0 = use round time)")
});